import * as React from 'react';
import './courseCompletionNotificationPane.module.scss';
import { ImageApis } from '../../../../../commonv3/api/images';
import { CourseCompletionNotification } from '../../../../types/notifications';
import { TwitterShareButton } from '../../../atoms/buttons/TwitterShareButton';
import { FacebookShareButton } from '../../../atoms/buttons/FacebookShareButton';

type Props = {
    notification?: CourseCompletionNotification;
};

export class CourseCompletionNotificationPane extends React.Component<Props> {
    render() {
        const { notification } = this.props;
        if (!notification) {
            return null;
        }
        const prefillText = `「${notification.course_title}」を修了しました！`;
        const ogpUrl = `https://likes.she-inc.jp/v3/courses/${notification.course_id}/completion_certificate`;
        return (
            <div styleName="pane">
                <img styleName="thumbnail" src={ImageApis.getUrlFor(notification.certificate_image)} />
                <div styleName="text main">{notification.course_title}を修了しました！</div>
                <div styleName="text sub">{notification.course_title}の課題をすべてクリアしました。</div>
                <div styleName="text sub">おめでとうございます！</div>
                <div styleName="button-toolbar">
                    <TwitterShareButton dataText={prefillText} dataUrl={ogpUrl}>
                        Twitterでシェア
                    </TwitterShareButton>
                    <FacebookShareButton dataUrl={ogpUrl}>Facebookでシェア</FacebookShareButton>
                </div>
            </div>
        );
    }
}
